// src/components/ProtectedRoute.jsx
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBalance } from './BalanceContext';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const {authSuccess,authFinished} = useAuth();
  const { tokenBalance,fetched} = useBalance();

  
  
  // tokenBalance が取得済みで 50 未満の場合、元の場所の情報を state に含めてリダイレクト
  if ((!authSuccess && authFinished)){
    return (
      <Navigate
        to="/not-connected"
        replace
        state={{ from: location }}
      />
    );
  }else if (authSuccess && authFinished && fetched && tokenBalance < 50) {
    return (
      <Navigate
        to="/insufficient-balance"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
